var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5007 10.8333H14.084",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 3.25H17.8757C18.3783 3.25 18.6307 3.25 18.842 3.27817C19.551 3.37168 20.2094 3.69646 20.7151 4.20217C21.2209 4.70788 21.5456 5.36629 21.6392 6.07533C21.6673 6.28658 21.6673 6.539 21.6673 7.04167",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8337 12.7812C23.8337 9.92982 23.8337 8.50307 22.9995 7.57682C22.923 7.49135 22.842 7.40998 22.7568 7.33307C21.8306 6.49999 20.4038 6.49999 17.5525 6.49999H17.1473C15.8982 6.49999 15.2732 6.49999 14.6903 6.33424C14.3705 6.24281 14.0622 6.11486 13.7717 5.95291C13.243 5.65932 12.801 5.21624 11.917 4.33332L11.3212 3.73749C11.0243 3.44066 10.877 3.29332 10.721 3.16332C10.05 2.60718 9.22701 2.26626 8.35933 2.18507C8.15783 2.16666 7.94766 2.16666 7.52949 2.16666C6.57291 2.16666 6.09516 2.16666 5.69649 2.24249C4.84048 2.40415 4.05307 2.82005 3.43699 3.43595C2.82091 4.05184 2.40475 4.83912 2.24283 5.69507C2.16699 6.09482 2.16699 6.57366 2.16699 7.52916M23.8239 17.3333C23.7849 20.02 23.5856 21.5421 22.564 22.5637C21.2954 23.8333 19.2522 23.8333 15.167 23.8333H10.8337C6.74841 23.8333 4.70524 23.8333 3.43666 22.5637C2.16808 21.294 2.16699 19.2519 2.16699 15.1667V11.9167",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFiles);
export default __webpack_public_path__ + "static/media/project-files.5469769ac0424379895a11bebb934e23.svg";
export { ForwardRef as ReactComponent };